import _regeneratorRuntime from "/opt/www/game/xcp-vue-xcll/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/opt/www/game/xcp-vue-xcll/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.concat.js";
import serverList from "../../components/serverList/serverOptions.vue";
import DataOptions from "../../components/timeList/dataOptions.vue";
import infoList from "@/mixins/infoList";
import { ltvGameData } from "@/api/data";
export default {
  name: "ItvGameData",
  mixins: [infoList],
  components: {
    serverList: serverList,
    DataOptions: DataOptions
  },
  data: function data() {
    return {
      listApi: ltvGameData,
      searchInfo: {
        server_id: ["0"]
      },
      formData: [this.$moment().subtract(7, "days").format("YYYY-MM-DD"), this.$moment().format("YYYY-MM-DD")]
    };
  },
  mounted: function mounted() {
    var _this = this;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _this.searchEvent();
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  methods: {
    loadTatleData: function loadTatleData() {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this2.loading = true;
              _context2.next = 3;
              return _this2.getTableData();
            case 3:
              //对 Table 进行重新布局。当 Table 或其祖先元素由隐藏切换为显示时，可能需要调用此方法
              //否则出现表格混乱
              if (!_this2.tableData || _this2.tableData.length === 0) {
                _this2.$message({
                  message: "暂无数据"
                });
              }
              _this2.$refs["table"].doLayout();
              _this2.loading = false;
            case 6:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    searchEvent: function searchEvent() {
      this.searchInfo.sdate = this.formData[0];
      this.searchInfo.edate = this.formData[1];
      this.loadTatleData();
    },
    open2: function open2() {
      this.$notify({
        title: "Ltv数据",
        message: "(1)查询当前已开所有服务器的LTV数据，以角色为维度做数据统计。" + "(2)可选择日期段，每一行为一天的数据，第一行为所选日期合计的数据。可选择一个或者多个服的数据，选择多个服时，直接数据累加。" + "(3)打开默认选中最近7天，全服数据，但不查询，需要手动点查询后再展示数据。" + " (4)数据列包括创角、终生ltv、1至14天每天ltv、ltv21、ltv28、ltv30、ltv45、ltv60、ltv90、ltv120、ltv150、ltv180。",
        duration: 0
      });
    },
    toDecimal2: function toDecimal2(x) {
      return this.cal.toDecimal2(x);
    },
    getSummaries: function getSummaries(param) {
      var _this3 = this;
      var columns = param.columns;
      var sums = [];
      columns.forEach(function (column, index) {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        if (column.property == "new_role") {
          sums[index] = _this3.tableDataCount[column.property];
          return;
        }
        if (column.property == "pay_user") {
          sums[index] = "".concat(_this3.tableDataCount[column.property], "(").concat(_this3.tableDataCount['pay_average'], ")");
          return;
        }
        if (column.property == "ltv") {
          var newRole = _this3.tableDataCount["new_role"];
          var ltv = _this3.tableDataCount[column.property];
          var ltvDivNewRole = newRole > 0 ? _this3.cal.toDecimal2(ltv / newRole) : 0;
          sums[index] = ltv + "(" + ltvDivNewRole + ")";
          return;
        }
        var ltvTwo = _this3.tableDataCount[column.property];
        var newRoleTwo = _this3.rspData.expectUserCount["new_user_expect_" + column.property];
        var ltvDivNewRoleTwo = newRoleTwo > 0 ? _this3.cal.toDecimal2(ltvTwo / newRoleTwo) : 0;
        sums[index] = ltvTwo + "(" + ltvDivNewRoleTwo + ")";
      });
      return sums;
    }
  }
};